import { useViewProvider } from '../../contexts/view-provider-context/ViewProvider';
import { ReactElement } from 'react';
import { ApiErrorModalContentViewProps } from './ApiErrorModalContentViewProps';

export function ApiErrorModalContent(props: ApiErrorModalContentViewProps): ReactElement {
  const viewProvider = useViewProvider();

  return viewProvider.renderApiErrorModalContent(props);
}
